// extracted by mini-css-extract-plugin
export var button = "_5z-0";
export var icon = "_5z-1";